import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useResourceCategories() {
  const [loading, setLoading] = useState(true);
  const [resourceCategories, setResourceCategories] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.resource_categories.index)
      .then((response) => {
        setResourceCategories(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, resourceCategories };
}
